// A monotonically increasing "the alert feed changed" signal.
//
// Push messages tell the dashboard that a new bell exists, but the payload is a
// notification — not the authoritative alert row. Rather than splice a
// half-populated item into the list, subscribers re-fetch from
// GET /api/admin/alerts, which keeps the server as the single source of truth
// (CLAUDE.md: business-critical timestamps never originate on the client).
//
// Panels consume this through useApi's dependency array, so a bump reloads the
// feed and the unread badge without a page refresh.

import { useSyncExternalStore } from "react";

let revision = 0;
const listeners = new Set<() => void>();

/** Marks the alert feed stale; every subscribed panel re-fetches. */
export function bumpNotificationRevision(): void {
  revision += 1;
  for (const l of listeners) l();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function snapshot(): number {
  return revision;
}

// Server render is always revision 0 — the value only advances client-side in
// response to a live message.
function serverSnapshot(): number {
  return 0;
}

/** Subscribes a component to feed-invalidation bumps. */
export function useNotificationRevision(): number {
  return useSyncExternalStore(subscribe, snapshot, serverSnapshot);
}
